import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  margin: 0 24px;
  flex: 1;
`;

export const ButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const Button = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const ButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const TextSpotlight = styled.Text`
  margin-bottom: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const FooterButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;
